import React from "react";
import "./WhatItCan.css";
// Background Images
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import { FormattedMessage } from "react-intl";

export default function Index({ data }) {
  return (
    <section className="what-it-can-do">
      <RightBox className="right-box-shape" />
      <div className="container">
        <div className="title">
          <h2>
            <FormattedMessage id="what_it_can_do" />
          </h2>
        </div>
        {data.features.length > 0
          ? data.features.map((item, index) => (
              <div className={index % 2 !== 0 ? "row even" : "row flex-row-reverse odd"}>
                <div className="col-lg-6">
                  <div className="text-box">
                    <div className="table-cell">
                      <h3 className="accent">
                        <FormattedMessage id={item.title} />
                      </h3>
                      {item.sub_title
                        ? item.sub_title.map((item) => (
                            <h5 className="accent">
                              <FormattedMessage id={item} />
                            </h5>
                          ))
                        : null}
                      {item.text ? (
                        item.text.length > 0 ? (
                          item.text.map((text) => (
                            <p>
                              <FormattedMessage id={text} />
                            </p>
                          ))
                        ) : (
                          <p>
                            <FormattedMessage id={item.text} />
                          </p>
                        )
                      ) : null}
                      {item.list ? (
                        item.list.length > 0 ? (
                          <ul>
                            {item.list.map((list) => (
                              <li>
                                <FormattedMessage id={list} />
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <li>
                            <FormattedMessage id={item.list} />
                          </li>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  {item.img ? (
                    <div className="img-box">
                      <img src={item.img} alt="goopter flashbot" />
                    </div>
                  ) : null}

                  {item.video ? (
                    <div className="video-box">
                      <iframe
                        src={item.video}
                        width="520"
                        height="270"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </div>
                  ) : null}
                </div>
              </div>
            ))
          : null}
      </div>
    </section>
  );
}
